import { inject, injectable } from "@launchtray/tsyringe-async";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { IMediumWinCoinsController } from "./IMediumWinCoinsController";

@injectable()
export class MediumWinCoinsController implements IMediumWinCoinsController {
    private readonly playerModel: IPlayerModel;

    public constructor(@inject("IPlayerModel") playerModel: IPlayerModel) {
        this.playerModel = playerModel;
    }

    public collectCoins(value: number): void {
        this.playerModel.addCoins(value);
    }
}